import { AppConfigActions } from 'src/store/actions/appConfigActions';
import { THEME_LS_KEY } from 'src/style/themes';
const initialState = {
    theme: localStorage.getItem(THEME_LS_KEY) || 'lightOrange'
};
export default (state = initialState, { type, payload }) => {
    switch (type) {
        case AppConfigActions.SET_APP_THEME: {
            localStorage.setItem(THEME_LS_KEY, payload);
            return {
                ...state,
                theme: payload
            };
        }
        default: {
            return state;
        }
    }
};
